exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell{width:33.333%;height:90px;border:6px solid #2c3e50;font-size:3.5em;font-family:Gochi Hand,sans-serif}.cell:hover{background-color:#7f8c8d}.cell:after{content:\"\";display:block}.cell:first-of-type{border-left-color:transparent}.cell:first-of-type,.cell:nth-of-type(2),.cell:nth-of-type(3){border-top-color:transparent}.cell:nth-of-type(3){border-right-color:transparent}tr:nth-of-type(3) .cell{border-bottom-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c804f69","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cell.vue
// module id = 21
// module chunks = 0